import React, { useState, useEffect, CSSProperties } from 'react';

import { ReactComponent as Chevron } from './chevron-icon.svg';

interface RequiredItemProperties<T> {
  value: T;
  label: string;
}

interface CustomSelectProps<A, T extends RequiredItemProperties<A>> {
  selectedItem?: T;
  items: T[];
  onChange?: (newValue: T) => void;
  placeholder?: string;
  icon?: string | null;
  style?: CSSProperties;
  margin?: string;
  padding?: string;
  disabled?: boolean;
  isData?: boolean;
  medium?: boolean;
}

function CustomSelect<A, T extends RequiredItemProperties<A>>(
  props: CustomSelectProps<A, T>
): JSX.Element {
  const {
    selectedItem,
    items,
    onChange,
    placeholder,
    icon,
    medium,
    style,
    margin,
    padding,
    disabled,
    isData,
  } = props;
  const [currentValue, setCurrentValue] = useState<T | null>(
    selectedItem || null
  );
  const [open, setOpen] = useState(false);
  const toggleOpen = () => setOpen((prev) => !prev);

  const updateValue = (newValue: T) => () => {
    setCurrentValue(newValue);

    if (onChange) onChange(newValue);
    toggleOpen();
  };

  useEffect(() => {
    setCurrentValue(selectedItem || null);
  }, [selectedItem]);

  const borderColor = () => {
    let className;
    if (open) className = 'open mainBlock-current-selected-item-container';
    if (!open) className = 'mainBlock-current-selected-item-container';
    if (isData) className = 'warn mainBlock-current-selected-item-container';
    return className;
  };

  return (
    <div className="mainBlock">
      <div
        className={borderColor()}
        style={style}
        onClick={!disabled ? toggleOpen : undefined}
      >
        {icon ? (
          <img
            className={
              medium
                ? 'mainBlock-current-selected-item-container-optionalIcon'
                : ''
            }
            src={icon}
            alt="icon"
          />
        ) : null}
        <div
          className="mainBlock-current-selected-item-text"
          style={{ padding }}
        >
          {currentValue?.label || placeholder || null}
        </div>
        <div className={`mainBlock-chevron-container ${!open ? 'revert' : ''}`}>
          <Chevron />
        </div>
      </div>
      <div className="mainBlock-dropped-overflow-container" style={{ margin }}>
        <div className={`mainBlock-dropped-block ${!open ? 'closed' : ''}`}>
          {items.map((el) => (
            <div
              key={JSON.stringify(el)}
              className="drop-item"
              onClick={updateValue(el)}
            >
              {el.label}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default CustomSelect;
